import { render, staticRenderFns } from "./ViewApp.vue?vue&type=template&id=28e21824&scoped=true"
import script from "./ViewApp.vue?vue&type=script&lang=js"
export * from "./ViewApp.vue?vue&type=script&lang=js"
import style0 from "./ViewApp.vue?vue&type=style&index=0&id=28e21824&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e21824",
  null
  
)

export default component.exports